module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/functions/licence/licence-grid/licence-grid.component.css
// module id = ./src/app/pages/functions/licence/licence-grid/licence-grid.component.css
// module chunks = main